<template>
  <header class="override-with-light-mode h-60 md:h-auto z-header">
    <div class="fixed w-full z-header md:static bg-surface-secondary">
      <div class="page-wrapper">
        <nav
          aria-label="Main"
          class="flex max-h-60 h-60 whitespace-nowrap items-center"
        >
          <NuxtLink
            to="https://www.halebop.se/"
            external
            aria-label="Gå till Halebops startsida"
            class="standalone flex flex-none"
          >
            <NuxtImg
              src="/images/logos/halebop_header_logo.svg"
              alt="halebop logga"
              class="h-32 w-112"
              width="112"
              provider="cloudfront"
              preload
            />
          </NuxtLink>
          <ul
            v-if="navLinks.length > 0"
            class="relative items-center w-full justify-between list-none p-0 m-0 ml-[4.5rem] mr-[4.5rem] xl:ml-[12.8rem] xl:mr-[12.8rem] h-full hidden lg:flex"
          >
            <li
              v-for="link in navLinks"
              :key="link.url + link.name"
              class="relative h-full content-center flex items-center"
            >
              <NuxtLink
                :to="link.url"
                external
                :class="[
                  'text-text-primary',
                  'hover:text-text-link-hover',
                  'visited:text-text-primary',
                  'p-8',
                  'no-underline',
                  'heading-xxs',
                  'standalone',
                  'hover:underline',
                  'focus:bg-transparent',
                ]"
              >
                {{ link.name }}
              </NuxtLink>
              <NuxtImg
                src="/images/sitewide/drop.svg"
                alt=""
                class="w-64 absolute top-0 left-0 right-0 ml-auto mr-auto hidden"
                width="64"
                provider="cloudfront"
                preload
              />
            </li>
          </ul>
          <div class="flex gap-16 ml-auto items-center">
            <HeaderGiosgPlaceHolder />
            <HeaderButton
              aria-label="Öppna popup med fler meny val"
              @on-click="((showNavModal = true), pushMenyClickEvent())"
            >
              MENY
            </HeaderButton>
            <HeaderButton
              href="/shop/varukorg"
              aria-label="Gå till varukorgen"
              button-type="button"
            >
              <nuxt-icon name="shopping-cart" aria-hidden="true" />
            </HeaderButton>
            <AppButton
              lang="sv"
              color="secondary"
              size="sm"
              class="min-w-44 relative"
              :class="[chatStore.isChatStarted ? 'block md:hidden' : 'hidden']"
              :full-width="true"
              aria-label="Öppna chat"
              button-type="button"
              @on-click="chatStore.ToggleChat()"
            >
              <NuxtIcon filled name="bar-chart" />
              <span
                class="absolute -right-4 -top-4 h-22 w-22 rounded-full bg-red-300 text-14"
                >{{ chatStore.newMessageNumber }}</span
              >
            </AppButton>
          </div>
        </nav>
      </div>
    </div>
  </header>
  <HeaderMenuModal v-model="showNavModal" />
</template>

<script lang="ts" setup>
const chatStore = useMyChatStore();
const navLinks = [
  {
    name: 'Mobiler',
    url: '/mobiltelefoner',
    isActive: false,
  },
  {
    name: 'Abonnemang',
    url: '/mobilabonnemang',
    isActive: false,
  },
  {
    name: 'Bredband',
    url: 'https://www.halebop.se/bredband',
    isActive: false,
  },
  {
    name: 'Erbjudanden',
    url: 'https://www.halebop.se/erbjudanden',
    isActive: false,
  },
  {
    name: 'Kontantkort',
    url: '/kontantkort',
    isActive: false,
  },
  {
    name: 'Om Halebop',
    url: 'https://www.halebop.se/om-halebop',
    isActive: false,
  },
];

const showNavModal: Ref<boolean> = ref(false);
const { pushMenyClickEvent } = useGoogleAnalyticsEvents();
</script>

<style scoped lang="scss">
.router-link-active + img {
  display: block;
}
</style>
